import { HeaderFilter, HeaderDateFilter } from "./HeaderFilter";

export const EMPTY_TRIP_FILTERS = { vehicle: "", driver: "", client: "", activity_type: "", date_from: "", date_to: "" };

const opts = (arr) => Array.from(new Set(arr.filter(Boolean).map((s) => String(s).trim()).filter(Boolean))).sort().map((v) => ({ value: v, label: v }));

export const TripTableHead = ({ isAll, filters, setFilters, statusFilter, onStatusChange, statusOptions, statusLabel,
  activityTypes, trucks, drivers, customers, rows }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  return (
    <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.2em] text-slate-600 border-b border-slate-200" data-testid="trip-table-head">
      <tr>
        <th className="px-3 py-3 text-left">
          <HeaderDateFilter from={filters.date_from} to={filters.date_to} onChange={(patch) => setFilters((f) => ({ ...f, ...patch }))} testid="filter-date" />
        </th>
        {isAll && <th className="px-3 py-3 text-left w-10"></th>}
        <th className="px-3 py-3 text-left">
          <HeaderFilter label="Status" value={statusFilter} onChange={onStatusChange} testid="filter-status"
            options={statusOptions.filter(Boolean).map((s) => ({ value: s, label: statusLabel(s) }))} />
        </th>
        <th className="px-3 py-3 text-left">
          <HeaderFilter label="Truck" value={filters.vehicle} onChange={set("vehicle")} testid="filter-truck"
            options={opts([...trucks.map((t) => t.vehicle_number), ...rows.map((r) => r.vehicle_number)])} />
        </th>
        <th className="px-3 py-3 text-left">
          <HeaderFilter label="Driver" value={filters.driver} onChange={set("driver")} testid="filter-driver"
            options={opts([...drivers.map((d) => d.name), ...rows.map((r) => r.driver_name)])} />
        </th>
        <th className="px-3 py-3 text-left">
          <HeaderFilter label="Client" value={filters.client} onChange={set("client")} testid="filter-client"
            options={opts([...customers.map((c) => c.name), ...rows.map((r) => r.client)])} />
        </th>
        <th className="px-3 py-3 text-left">
          <HeaderFilter label="Activity" value={filters.activity_type} onChange={set("activity_type")} testid="filter-activity"
            options={activityTypes.map((a) => ({ value: a.key, label: a.label }))} />
        </th>
        <th className="px-3 py-3 text-right">Fuel (L)</th>
        <th className="px-3 py-3 text-right">
          <div>Trips</div>
          <div className="text-[9px] tracking-[0.15em] text-slate-400 normal-case font-normal mt-0.5">done / cap · click to edit</div>
        </th>
        <th className="px-3 py-3 w-1"></th>
        <th className="px-3 py-3 text-right"></th>
      </tr>
    </thead>
  );
};
